import { createI18n } from 'vue-i18n';

function loadLocaleMessages() {
    const locales = import.meta.glob('./locales/**/*.json', { eager: true });
    const messages = {};

    Object.keys(locales).forEach((key) => {
        const matched = key.match(/([a-z0-9-]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales[key];
        }
    });

    return messages;
}

const i18n = createI18n({
    legacy: false,
    locale: import.meta.env.VITE_I18N_LOCALE || 'en',
    fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages(),
});

export default i18n;
